import { createAction, props } from '@ngrx/store';

export const setInvestigatorInformation = createAction(
  '[Investigator Form] Set Information',
  props<{ investigatorInfo: any }>(),
);

export const resetAllInvestigatorFields = createAction(
  '[Investigator Form] Reset All Fields',
);

export const resetOtherInvestigatorInformationFields = createAction(
  '[Investigator Form] Reset Other Information Fields',
);
